<template>
    <div class="p-4 space-y-4">
        <!-- Filters Card -->
        <div class="bg-white shadow rounded-xl p-5 border border-gray-400 ">
            <h2 class="text-gray-700 font-semibold mb-4">Filters</h2>

            <div class="grid sm:grid-cols-3 gap-4">
                <!-- Search -->
                <input type="text" placeholder="Search by Order No or Invoice No"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#CD7D00]/50" />

                <!-- Date Range -->
                <input type="text" placeholder="Select a date range"
                    class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#CD7D00]/50" />

                <!-- Buttons -->
                <div class="flex items-center gap-3">
                    <button class="px-4 py-2 border border-[#885502] bg-gradient-to-r from-[#FFD200] to-[#CD7D00] text-white rounded-full shadow
        transition-transform duration-200 ease-out hover:scale-105 hover:shadow-md">
                        Apply
                    </button>

                    <button class="px-4 py-2 bg-gray-200 text-gray-600 border border-gray-800 rounded-full shadow
        transition-transform duration-200 ease-out hover:scale-105 hover:shadow-md">
                        Reset
                    </button>
                </div>

            </div>
        </div>

        <!-- Desktop Table View -->
        <div class="hidden sm:block bg-white shadow rounded-xl border border-gray-400 overflow-hidden rounded-t-xl">
            <table class="w-full text-sm text-gray-700">

                <thead class="bg-gray-100  text-gray-600 text-left">
                    <tr>
                        <th class="py-3 px-4">Date</th>
                        <th class="py-3 px-4">Invoice No.</th>
                        <th class="py-3 px-4">Order No.</th>
                        <th class="py-3 px-4">Total</th>
                        <th class="py-3 px-4">Status</th>
                        <th class="py-3 px-4"></th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Row Example -->
                    <tr class="border-t">
                        <td class="py-3 px-4">14 October 2025</td>
                        <td class="py-3 px-4">INV0021</td>
                        <td class="py-3 px-4">DMRBX0006</td>
                        <td class="py-3 px-4">$303</td>
                        <td class="py-3 px-4">
                            <span
                                class="px-3 py-1 rounded-full text-xs font-semibold bg-[#9DFFCB] text-[#107C41] inline-flex items-center gap-1">
                                <i class="fa-solid fa-circle-check text-[13px]"></i>
                                Paid
                            </span>
                        </td>
                        <td class="py-3 px-4">
                            <button class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold 
  bg-gradient-to-r from-yellow-400 to-amber-600 text-white border
  transition-transform duration-200 ease-out hover:scale-105 hover:shadow-md">
                                <i class="fa-solid fa-download text-[13px]"></i>
                                Download
                            </button>

                        </td>
                    </tr>
                    <tr class="border-t">
                        <td class="py-3 px-4">14 October 2025</td>
                        <td class="py-3 px-4">INV0021</td>
                        <td class="py-3 px-4">DMRBX0006</td>
                        <td class="py-3 px-4">$303</td>
                        <td class="py-3 px-4">
                            <span
                                class="px-3 py-1 rounded-full text-xs hover:shadow-md hover:border-[#076933] cursor-pointer font-semibold bg-[#9DFFCB] text-[#107C41] inline-flex items-center gap-1">
                                <i class="fa-solid fa-circle-check text-[13px]"></i>
                                Paid
                            </span>
                        </td>
                        <td class="py-3 px-4">
                            <button class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold 
  bg-gradient-to-r from-yellow-400 to-amber-600 text-white border
  transition-transform duration-200 ease-out hover:scale-105 hover:shadow-md">
                                <i class="fa-solid fa-download text-[13px]"></i>
                                Download
                            </button>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


        <!-- Mobile Card View -->
        <div class="space-y-3 sm:hidden">
            <div class="bg-white shadow border border-gray-400 rounded-xl p-4 text-sm text-gray-700">
                <div class="flex justify-between items-center">
                    <div class="font-semibold text-gray-800">INV0021</div>
                    <span
                        class="px-2 py-1 text-xs font-semibold rounded-full bg-[#9DFFCB] text-[#107C41] inline-flex items-center gap-1">
                        <i class="fa-solid fa-circle-check text-[13px]"></i>
                        Paid
                    </span>
                </div>

                <div class="mt-2 space-y-1 text-gray-600">
                    <p><span class="font-semibold">Date:</span> 14 October 2025</p>
                    <p><span class="font-semibold">Order No:</span> DMRBX0006</p>
                    <p><span class="font-semibold">Total:</span> $303</p>
                </div>

                <div class="mt-3 flex justify-end">
                    <button
                        class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r border from-yellow-400 to-amber-600 text-white">
                        <i class="fa-solid fa-download text-[13px]"></i>
                        Download
                    </button>
                </div>
            </div>
            <div class="bg-white shadow border border-gray-400 rounded-xl p-4 text-sm text-gray-700">
                <div class="flex justify-between items-center">
                    <div class="font-semibold text-gray-800">INV0021</div>
                    <span
                        class="px-2 py-1 text-xs font-semibold rounded-full bg-[#9DFFCB] text-[#107C41] inline-flex items-center gap-1">
                        <i class="fa-solid fa-circle-check text-[13px]"></i>
                        Paid
                    </span>
                </div>

                <div class="mt-2 space-y-1 text-gray-600">
                    <p><span class="font-semibold">Date:</span> 14 October 2025</p>
                    <p><span class="font-semibold">Order No:</span> DMRBX0006</p>
                    <p><span class="font-semibold">Total:</span> $303</p>
                </div>

                <div class="mt-3 flex justify-end">
                    <button
                        class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r border from-yellow-400 to-amber-600 text-white">
                        <i class="fa-solid fa-download text-[13px]"></i>
                        Download
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
</script>
